import styled from 'styled-components';

import {Device} from '../../../../constants';

const VBucksTitle = styled.h2`
  && {
    color: #fff;
    text-align: center;
    line-height: 1;
    font-size: 1.5em;

    @media screen and ${Device.laptopL} {
      font-size: 1.5em;
    }
  }
`;

export default VBucksTitle;
